import 'whatwg-fetch';
import {EndpointURL, EntitiesApiEndpointURL} from '../constants';
import {actionFactory} from '../util/redux-helpers';
import {fetchWithAuth} from '../util/fetch';
import {push} from 'react-router-redux';

export const ACTIONS = {
  LoginInProgress: 'LOGIN_IN_PROGRESS',
  LoginCompleted: 'LOGIN_COMPLETED',
  LoginFailed: 'LOGIN_FAILED',
  LoginRedirect: 'LOGIN_REDIRECT',

  TokenRefreshInProgress: 'LOGIN_TOKEN_REFRESHING',
  TokenRefreshFailed: 'LOGIN_TOKEN_EXPIRED',
  TokenRefreshCompleted: 'LOGIN_TOKEN_REFRESHED',

  LoadCompanyInProgress: 'LOAD_ME_INPROGRESS',
  LoadCompanyFailed: 'LOAD_ME_FAILED',
  LoadCompanyCompleted: 'LOAD_ME_COMPLETED',

  Logout: 'LOGOUT'
};

const LoginInProgress = actionFactory(ACTIONS.LoginInProgress);
const LoginCompleted = actionFactory(ACTIONS.LoginCompleted);
const LoginFailed = actionFactory(ACTIONS.LoginFailed);
const LoginRedirect = actionFactory(ACTIONS.LoginRedirect);

const TokenRefreshInProgress = actionFactory(ACTIONS.TokenRefreshInProgress);
const TokenRefreshFailed = actionFactory(ACTIONS.TokenRefreshFailed);
const TokenRefreshCompleted = actionFactory(ACTIONS.TokenRefreshCompleted);


const LoadCompanyInProgress = actionFactory(ACTIONS.LoadCompanyInProgress);
const LoadCompanyFailed = actionFactory(ACTIONS.LoadCompanyFailed);
const LoadCompanyCompleted = actionFactory(ACTIONS.LoadCompanyCompleted);

export function RefreshTokenEpic(refreshToken) {
  return async function(dispatch) {
    dispatch(TokenRefreshInProgress());
    try {
      let authResult = await fetch(`${EndpointURL}auth/local/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          refresh_token: refreshToken
        })
      });
      if (authResult.status === 200){
        console.log('calling TokenRefreshCompleted');
        await dispatch(TokenRefreshCompleted(await authResult.json()));
      } else {
        await dispatch(TokenRefreshFailed('Session expired or not valid, please sign in again.'));
      }
    } catch (err) {
      await dispatch(TokenRefreshFailed('Error contacting authorization service, you have been logged off...'));
    }
    return Promise.resolve();
  }
}
export function ChangePasswordEpic(username, password, newPassword){
  return async function(dispatch){
    dispatch(LoginInProgress({username}));
    try {
      let authResult = await fetch(`${EndpointURL}auth/local/changePassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: username,
          password,
          newPassword
        })
      });
      if (authResult.status === 200){
        debugger;
        let authData = await authResult.json();

        let parentResult = await fetch(`${EntitiesApiEndpointURL}/parententity`,{headers: {Authorization: `Bearer ${authData.token}`}});
        let parentData = await parentResult.json();
        authData.companyRole = parentData.Role;

        dispatch(LoginCompleted(authData));
      } else if (authResult.status === 302) {
        dispatch(push('/ChangePassword'));
        dispatch(LoginRedirect(await authResult.json()));
      } else {
        let error = await authResult.text();
        dispatch(LoginFailed(error));
      }
    } catch (err) {
      dispatch(LoginFailed(err));
    }

  }
}
export function LoginEpic(username, password) {
  return async function(dispatch){
    dispatch(LoginInProgress({username}));
    try {
      let authResult = await fetch(`${EndpointURL}auth/local`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: username,
          password: password
        })
      });
      if (authResult.status === 200){
      
        let authData = await authResult.json();

        let parentResult = await fetch(`${EntitiesApiEndpointURL}/parententity`,{headers: {Authorization: `Bearer ${authData.token}`}});
        let parentData = await parentResult.json();
        authData.companyRole = parentData.Role;

        dispatch(LoginCompleted(authData));
      } else if (authResult.status === 302) {
        dispatch(push('/ChangePassword'));
        dispatch(LoginRedirect(await authResult.json()));
      } else {
        let error = await authResult.text();
        dispatch(LoginFailed(error));
      }
    } catch (err) {
      dispatch(LoginFailed(err));
    }

  }
}


export function LoadCompanyEpic(id) {
  return async function(dispatch) {
    dispatch(LoadCompanyInProgress());
    try {
      let companyResult = await fetchWithAuth(`${EndpointURL}admin/companies/${id}`);
      if (companyResult.status === 200){
        dispatch(LoadCompanyCompleted(await companyResult.json()));
      } else {
        let err = await companyResult.text();
        dispatch(LoadCompanyFailed(err));
      }
    } catch(e) {
      dispatch(LoadCompanyFailed(e));
    }
  }
}
export function Logout(){
  return { type: ACTIONS.Logout };
}



// WEBPACK FOOTER //
// ./src/actions/auth.actions.js